// --------------------------------------------------
// Print / Save as PDF
// Any [data-print] control opens the browser's native print dialog, whose
// "Save as PDF" destination lets the user download the page. The print
// stylesheet (site/print.scss) strips site chrome so the output is just the
// article. Delegated so it works regardless of how many triggers are present.
// --------------------------------------------------

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-print]');

  if (!trigger) {
    return;
  }

  event.preventDefault();
  window.print();
});
